import React, { useEffect, useState } from "react";

import useFetch from "../../shared/hooks/useFetch";

import DocumentList from "../components/DocumentList";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import Header from "../../shared/components/UIElements/Header";
import Container from "../../shared/components/UIElements/Container";

const AllDocuments = () => {
	const [documents, setDocuments] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const fetchDocs = useFetch();

	const fetchDocuments = async () => {
		const uri = `/api/documents/`;

		setIsLoading(true);

		fetchDocs(uri)
			.then((data) => {
				console.log(data);
				setDocuments(data.documents);
				setIsLoading(false);
			})
			.catch((error) => console.error(error));
	};

	useEffect(() => {
		fetchDocuments();
	}, []);

	return (
		<>
			<Header
				label="🔒 Alleen voor beheerders"
				title="Alle documenten"
				subtitle="Elk document dat gemaakt is met DentGPT"
				className="border-b-2 border-gray-100"
				style={{ backgroundColor: "#fff" }}
			/>
			<div className=" bg-slate-50">
				<Container>
					{isLoading && (
						<div className="flex py-10 justify-center">
							<LoadingSpinner />
						</div>
					)}
					<DocumentList documents={documents} />
				</Container>
			</div>
		</>
	);
};

export default AllDocuments;
